import { gql, TypedDocumentNode } from "@apollo/client";
import { ServerError } from "@flaminem/utils";

import {
  BlacklistElement,
  EnableBlacklistElementMutation,
  EnableBlacklistElementMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { blacklistElementFragment } from "src/graphql/anti-fraud/fragments/BlacklistElementFragment.ts";
import { usePerformMutation } from "src/graphql/utils";

export const enableBlacklistElement = gql`
  mutation EnableBlacklistElement($id: ID!) {
    enableBlacklistElement(id: $id) {
      ...BlacklistElement
    }
  }

  ${blacklistElementFragment}
` as TypedDocumentNode<EnableBlacklistElementMutation, EnableBlacklistElementMutationVariables>;

type UseEnableBlacklistElementMutationProps = {
  onSuccess: (data: BlacklistElement | null | undefined) => void;
  onError: (error: ServerError) => void;
};

export const useEnableBlacklistElementMutation = ({
  onSuccess,
  onError,
}: UseEnableBlacklistElementMutationProps) => {
  return usePerformMutation(enableBlacklistElement, {
    onSuccess: (data) => {
      onSuccess(data?.enableBlacklistElement as BlacklistElement);
    },
    onError,
  });
};
